import { createApp } from 'vue';
import ImageViewer from './index.vue';
const divEl = document.createElement('div');
const app = createApp(ImageViewer, { divEl });
const vm = app.mount(divEl);
document.body.appendChild(divEl);
const ImagePreview = (urls, options) => {
  let imageArray = [];
  if (typeof urls === 'string') imageArray = Object.assign([], [urls]);
  if (urls instanceof Array) imageArray = Object.assign([], urls);
  vm.urlList = imageArray;
  if (options && Object.keys(options).length) {
    for (const key in options) {
      if (Object.prototype.hasOwnProperty.call(options, key)) {
        const element = options[key];
        vm.options[key] = element;
      }
    }
  }
  vm.isShow = true;
};
export default ImagePreview;
